<div #mapWrapper id="map">
    <arcgis-map zoom="4"  #mapDiv  class="map" (arcgisViewReadyChange)="arcgisViewReadyChange($event)" basemap="hybrid">
        <arcgis-zoom position="top-left"></arcgis-zoom>
        <arcgis-search position="top-right" #mapSearch></arcgis-search>
        <arcgis-expand
            close-on-esc
            position="bottom-right"
        >
            <arcgis-basemap-gallery></arcgis-basemap-gallery>
        </arcgis-expand> 
        <arcgis-expand
            expanded
            close-on-esc
            position="bottom-left"
            mode="floating"
            expand-icon="legend"
            #legend
        >
            <arcgis-placement>
                <div class="legend">
                    <h5 class="legend-title">Record Status</h5>
                    <ul class="status-legend">
                        <li>
                            <span class="legend-span active"></span>
                            Active
                        </li>
                        <li>
                            <span class="legend-span canceled"></span>
                            Canceled
                        </li>
                        <li>
                            <span class="legend-span completed"></span>
                            Completed
                        </li>
                        <li>
                            <span class="legend-span proposed"></span>
                            Proposed
                        </li>
                    </ul>
                </div>
            </arcgis-placement>
        </arcgis-expand>
    </arcgis-map>
</div>

